import { CLIENT_AUTHORIZATION_PLACE } from "../../common/constant"

import styles from "./style.module.scss"

import { Icon } from "components"

interface Props {
    place?: CLIENT_AUTHORIZATION_PLACE
    onClick: () => void
}

export const SecondHeader = ({ place, onClick }: Props) => {
    if (place === CLIENT_AUTHORIZATION_PLACE.MAIN) {
        return (
            <h1 className={styles.goBack} onClick={onClick}>
                <div className={styles.goBackIcon}>
                    <Icon type="long-arrow-left-green" size={24} />
                </div>
                <div>Вход в Мой Alter</div>
            </h1>
        )
    }

    if (place === CLIENT_AUTHORIZATION_PLACE.MODAL) {
        return (
            <h1 className={styles.modalHeader} onClick={onClick}>
                <Icon type="arrow-left-green" size={24} className={styles.modalIcon} />
                <span className={styles.modalText}>Назад</span>
            </h1>
        )
    }
    return null
}
